module.exports = __webpack_public_path__ + "static/media/s_brown_2.7d050f80.mp3";